import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    Roles,
    RoleAttribute,
    RoleDashBoards,
    RoleSecurityDetails,
    RoleAttributesAdd,
    FilteredAttributes,
    AssignAttributesToRole,
    GetRoleSecurity,
    GetFilteredSecurities,
    GetRoleDashBoardsToAdd,
    GetAddRoleDashBoard,
    AssignSecurityCodesToRole,
    GetDeleteAttribute,
    GetDeleteRoleDashBoard,
    GetDeletePrivilege,
    GetUpdateRoleAttribute,
} from '../../Redux/Admin_Tasks/ManageRoleSlice'

import { AppDispatch, RootState } from '../../Redux/store'
import PopUp from './AddAttributeToRole'
import AddPrivilegetoRole from './AddPrivilegeToRole'
import AddWorkspacetoRole from './AddWorkSpaceToRole'
import AddAttributetoRoleDelete from './AddAttributeToRoleDelete';
import { Console } from 'console';
import AddPrivilegetoRoleDelete from './AddPrivilegeToRoleDelete';
import AddWorkSpacetoRoleDelete from './AddWorkSpaceToRoleDelete';
import { getBaseUrl } from '../../Utils';
import { Skeleton } from '../../GenericComponents/Skeleton';
import { SearchItem } from '../../GenericComponents/searchlistCallbacks'
import HLServerSearchListDialog from '../../GenericComponents/hlServerSearchListDialog'
import { useTitleContext } from "../../Hooks/useTitleContext";


const ManageRoles: React.FC = () => {

    const { setTitle } = useTitleContext();
    setTitle("Manage Roles");

    const dispatch: AppDispatch = useDispatch()
    const [selectedRoleId, setSelectedRoleId] = useState<number | null>(null)
    const [showAddAttribute, setShowAddAttribute] = useState(false)
    const [showAddPrivilegeRole, setShowAddPrivilegeRole] = useState(false)
    const [showAddWorkspaceRole, setShowAddWorkspaceRole] = useState(false)
    // const [selectedDashboardId, setSelectedDashboardId] = useState<number | null>(null)
    const [selectedWorkspaceId, setSelectedWorkspaceId] = useState<number | null>(null)
    const [searchResults, setSearchResults] = useState<{ MetaDataId: number; FieldName: string }[]>(
        []
    )
    const [searchTerm, setSearchTerm] = useState<string>('')
    const [searchAddPrivilegeRole, setAddPrivilegeRole] = useState<string>('')
    const [assignedAttributes, setAssignedAttributes] = useState<number[]>([])
    const [securityKeys, setSecurityKeys] = useState<number[]>([])
    const [pId, setPId] = useState<number | null>(null) // Manage dynamic pID
    const [dashBoardId, setDashBoardId] = useState<number | null>(null)
    const [showRemoveAddAttributeRole, setshowRemoveAddAttributeRole] = useState(false)
    const [showRemoveAddWorkSpaceRole, setshowRemoveAddWorkSpaceRole] = useState(false)
    const [showRemoveAddPrivilegeRole, setshowRemoveAddPrivilegeRole] = useState(false)
    const [currentRoleId, setCurrentRoleId] = useState<number | null>(null)
    const [statusMessage, setStatusMessage] = useState<string | null>(null) //Status message
    const [messageVisible, setMessageVisible] = useState(false) // State to control message visibility
    const statusMessageRef = useRef<HTMLDivElement | null>(null)
    const [implicitFilters, setImplicitFilters] = useState<{ [key: number]: boolean }>({}) // State for the checkbox
    const [loading, setLoading] = useState(true);
    const [localRolesStatus, setLocalRolesStatus] = useState<'idle' | 'loading' | 'succeeded' | 'failed'>('idle');
    // Selectors for data from Redux store
    const roles = useSelector((state: RootState) => state.rolesdata.roles)
    const roleAttributes = useSelector((state: RootState) => state.rolesdata.roleAttributes)
    const roledashBoards = useSelector((state: RootState) => state.rolesdata.roledashBoards)
    const roleSecurityDetails = useSelector(
        (state: RootState) => state.rolesdata.roleSecurityDetails
    )
    const roleattributesadd = useSelector((state: RootState) => state.rolesdata.roleattributesAdd)
    const getfilteredattributes = useSelector(
        (state: RootState) => state.rolesdata.getfilteredattributes
    )
    const assignAttributesToRole = useSelector(
        (state: RootState) => state.rolesdata.assignAttributesToRole
    )
    const getRoleSecurity = useSelector((state: RootState) => state.rolesdata.getroleSecurities)
    const getfilteredsecurities = useSelector(
        (state: RootState) => state.rolesdata.getfilteredsecurities
    )
    const assignSecurityCodesToRole = useSelector(
        (state: RootState) => state.rolesdata.assignSecurityCodesToRole
    )
    const getRoleDashBoardsToAdd = useSelector(
        (state: RootState) => state.rolesdata.getRoleDashBoardsToAdd
    )
    const addRoleDashBoard = useSelector((state: RootState) => state.rolesdata.addRoleDashBoard)
    const deleteAttribute = useSelector((state: RootState) => state.rolesdata.deleteAttribute)
    const deletePrivilege = useSelector((state: RootState) => state.rolesdata.deletePrivilege)
    const updateRoleAttribute = useSelector(
        (state: RootState) => state.rolesdata.updateRoleAttribute
    )
    const status = useSelector((state: RootState) => state.rolesdata.status)
    const error = useSelector((state: RootState) => state.rolesdata.error)

    useEffect(() => {
      const fetchRolesAndAttributes = async () => {
          try {
              setLocalRolesStatus('loading');
              const fetchedRoles = await dispatch(Roles()).unwrap();
              setLocalRolesStatus('succeeded');
              let firstRoleId;
              if (selectedRoleId !== null) {
                  // If a role is already selected, retain it
                  firstRoleId = selectedRoleId;
              } else if (fetchedRoles.length > 0) {
                  firstRoleId = fetchedRoles.find((role:any) => role.isDefault)?.id || fetchedRoles[0].id;
              } else {
                  console.warn("No roles available to select.");
                  return;
              }
              setSelectedRoleId(firstRoleId);
          } catch (err) {
              console.error("Error fetching roles or attributes:", err);
          }
      };  
      fetchRolesAndAttributes();
  }, [dispatch]);
 
  useEffect(() => {
      const fetchRoleData = async () => {
          if (selectedRoleId !== null) {
              // Fetch data related to the selected role
              await Promise.all([
                  dispatch(RoleAttribute(selectedRoleId)).unwrap(),
                  dispatch(RoleDashBoards(selectedRoleId)).unwrap(),
                  dispatch(RoleSecurityDetails(selectedRoleId)).unwrap(),
                  dispatch(RoleAttributesAdd(selectedRoleId)).unwrap(),
                  dispatch(FilteredAttributes({ roleId: selectedRoleId, searchstring: '' })).unwrap(),
                  dispatch(GetRoleSecurity(selectedRoleId)).unwrap(),
                  dispatch(GetFilteredSecurities({ roleId: selectedRoleId, searchString: '' })).unwrap(),
                  dispatch(GetRoleDashBoardsToAdd(selectedRoleId)).unwrap(),
              ]);
          }
      };
      fetchRoleData();
  }, [dispatch, selectedRoleId]);


    const handleRoleChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
        const id = parseInt(event.target.value, 10)
        setSelectedRoleId(id)
        await Promise.all([
            dispatch(RoleAttribute(id)),
            dispatch(RoleDashBoards(id)),
            dispatch(RoleSecurityDetails(id)),
            dispatch(RoleAttributesAdd(id)),
            dispatch(FilteredAttributes({ roleId: id, searchstring: '' })),
            dispatch(GetRoleSecurity(id)),
            dispatch(GetFilteredSecurities({ roleId: id, searchString: '' })),
            dispatch(GetRoleDashBoardsToAdd(id)),
        ])
    }
    useEffect(() => {
        if (status === "succeeded") {
          setLoading(false);
        }
      }, [status]);
    
    useEffect(() => {
        if (selectedRoleId !== null) {
            dispatch(RoleAttribute(selectedRoleId))
        }
    }, [selectedRoleId, assignedAttributes, dispatch])

    useEffect(() => {
        if (messageVisible && statusMessageRef.current) {
            statusMessageRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }, [statusMessage, messageVisible])

    const handleSaveAttributes = async (attrKeys: any) => {
      const transformedAttrKeys = attrKeys.map((attr: any) =>({ 
        MetaDataId: attr.KeyValue,   
        FieldName: attr.DisplayText,
      }));
      if (selectedRoleId !== null) {
            try {
                await dispatch(
                  AssignAttributesToRole({ roleId: selectedRoleId, attrKeys: transformedAttrKeys.map((attr: { MetaDataId: any }) => attr.MetaDataId) })
                ).unwrap()
                await dispatch(RoleAttribute(selectedRoleId)).unwrap()
                await dispatch(RoleAttributesAdd(selectedRoleId)).unwrap();               
                setStatusMessage('Attribute added for this role successfully.')
                setMessageVisible(true)
                setShowAddAttribute(false)
            } catch (error) {
                console.error('Failed to assign attributes to role:', error)
            }
        }
    }

    // Function to clear the status message
    const clearStatusMessage = () => {
        setStatusMessage(null)
        setMessageVisible(false)
    }

    // Effect to hide status message when the state is updated
    useEffect(() => {
        if (!messageVisible) {
            setStatusMessage(null)
        }
    }, [messageVisible])

    useEffect(() => {
        if (selectedRoleId !== null) {
            dispatch(RoleAttribute(selectedRoleId))
        }
    }, [selectedRoleId, securityKeys, dispatch])

    //Save function Add Privilege to Role
    const handleSavePrivilege = async (secKeys: number[]) => {
        if (selectedRoleId !== null) {
            try {
                await dispatch(
                    AssignSecurityCodesToRole({ roleId: selectedRoleId, secKeys })
                ).unwrap()
                await dispatch(RoleSecurityDetails(selectedRoleId)).unwrap()
                setStatusMessage('Privilege added for this role successfully.') // Set the success message
                setMessageVisible(true)
                setShowAddPrivilegeRole(false)
            } catch (error) {
                console.error('Failed to assign security codes to role:', error)
            }
        }
    }

    //Save function Add Workspace to Role
    const handleSaveWorkspace = async (dashBoardId: number) => {
        if (selectedRoleId !== null) {
            try {
                await dispatch(
                    GetAddRoleDashBoard({ roleId: selectedRoleId, dashBoardId })
                ).unwrap()
                await dispatch(RoleDashBoards(selectedRoleId)).unwrap()
                await dispatch(GetRoleDashBoardsToAdd(selectedRoleId)).unwrap()
                setStatusMessage('Added workspace for this role successfully.')
                setMessageVisible(true)
                setShowAddWorkspaceRole(false)
            } catch (error) {
                console.error('Failed to assign security codes to role:', error)
            }
        }
    }

    useEffect(() => {
        if (selectedRoleId !== null) {
            dispatch(GetRoleSecurity(selectedRoleId))
                .unwrap()
                .catch((error) => {
                    console.error('Failed to fetch role security details:', error)
                })
        }
    }, [dispatch, selectedRoleId, showAddPrivilegeRole])

    //Remove Function Add Attribute to Role
    const handleAddAttributetoRoleRemoveClick = async () => {
        clearStatusMessage()
        if (pId !== null && selectedRoleId !== null) {
            try {
                await dispatch(GetDeleteAttribute({ roleId: selectedRoleId, pID: pId })).unwrap()
                await dispatch(RoleAttribute(selectedRoleId)).unwrap()
                setAssignedAttributes((prev) => prev.filter((attr) => attr !== pId))
                await dispatch(
                    FilteredAttributes({ roleId: selectedRoleId, searchstring: '' })
                ).unwrap()
                await dispatch(RoleAttributesAdd(selectedRoleId)).unwrap()
                setshowRemoveAddAttributeRole(false)
                setStatusMessage('Removed attribute for this role successfully.')
                setMessageVisible(true)
            } catch (error) {
                console.error('Error deleting attribute:', error)
            }
        } else {
            console.error('pId or selectedRoleId is null')
        }
    }

    //Remove Function Add Privilege to Role
    const handleAddPrivilegetoRoleRemoveClick = async () => {
        clearStatusMessage()
        if (pId !== null && selectedRoleId !== null) {
            try {
                await dispatch(GetDeletePrivilege({ roleId: selectedRoleId, pID: pId })).unwrap()
                await dispatch(GetRoleSecurity(selectedRoleId)).unwrap()
                await dispatch(
                    GetFilteredSecurities({ roleId: selectedRoleId, searchString: '' })
                ).unwrap()
                await dispatch(RoleSecurityDetails(selectedRoleId)).unwrap()
                setshowRemoveAddPrivilegeRole(false)
                setStatusMessage('Removed privilege for this role successfully.')
                setMessageVisible(true)
            } catch (error) {
                console.error('Error deleting attribute:', error)
            }
        } else {
            console.error('pId or selectedRoleId is null')
        }
    }

    const handleAddWorkspacetoRoleRemoveClick = async () => {
        clearStatusMessage()
        if (dashBoardId !== null && selectedRoleId !== null) {
            try {
                await dispatch(
                    GetDeleteRoleDashBoard({ roleId: selectedRoleId, dashBoardId })
                ).unwrap()
                await dispatch(RoleDashBoards(selectedRoleId)).unwrap()
                await dispatch(GetRoleDashBoardsToAdd(selectedRoleId)).unwrap()
                setshowRemoveAddWorkSpaceRole(false)
                setStatusMessage('Removed workspace for this role successfully.')
                setMessageVisible(true)
            } catch (error) {
                console.error('Error deleting workspace:', error)
            }
        } else {
            console.error('DashBoardId or selectedRoleId is null', { dashBoardId, selectedRoleId })
        }
    }

    useEffect(() => {
        const initialFilters = roleAttributes.dTO_RoleAttributes.AttrDetails.reduce(
            (acc:any, attr:any) => {
                if (attr) {
                    acc[attr.MetadataId] = attr.ImplicitFilter || false // Set default to false if not defined
                }
                return acc
            },
            {} as { [key: number]: boolean }
        )
        setImplicitFilters(initialFilters)
    }, [roleAttributes])

    // Checkbox change handler
    const handleCheckboxChange = async (metadataId: number) => {
        if (selectedRoleId !== null && metadataId !== undefined) {
            const currentChecked = implicitFilters[metadataId] || false
            try {
               // Clear any existing message first
                 setMessageVisible(false)
                setStatusMessage('')
                // Update local state based on the checkbox's current state
                const newChecked = !currentChecked
                setImplicitFilters((prev) => ({
                    ...prev,
                    [metadataId]: newChecked,
                }))
                // Dispatch the update action with the new checked state
                await dispatch(
                    GetUpdateRoleAttribute({
                        roleId: selectedRoleId.toString(),
                        pId: metadataId,
                        IsImplictFilter: newChecked,
                    })
                ).unwrap()
                setTimeout(() => {
                setStatusMessage('Attribute for this role updated successfully.')
                setMessageVisible(true)
            }, 200)
            } catch (error) {
                console.error('Failed to update attribute:', error)
            }
        }
    }

	const handleFind = (filterText: string): Promise<SearchItem[] | String> => {

		const filteredAttributes = Array.isArray(getfilteredattributes.attributeList)
			? getfilteredattributes.attributeList
			: [];
		const roleAttributes = Array.isArray(roleattributesadd.roleSecurities?.RoleAttributes)
			? roleattributesadd.roleSecurities.RoleAttributes
			: [];

		const combined_attributes = [...roleAttributes, ...filteredAttributes]
		const attributes = Array.from(
			new Map(combined_attributes.map((item) => [item.MetaDataId, item])).values()
		).sort((a, b) => a.FieldName.localeCompare(b.FieldName)); 
		console.log("Attributes:", attributes);
		let results: SearchItem[];

		if (!filterText?.trim()) {
			// If filterText is empty or only spaces, return all attributes
			results = attributes.map((item) => ({
				KeyValue: item.MetaDataId,
				DisplayText: item.FieldName,
			}));
		} else {
			// Perform  match search (case-insensitive)
			results = attributes
				.filter((item) => item.FieldName.toLowerCase().includes(filterText.toLowerCase()))
				.map((item) => ({
					KeyValue: item.MetaDataId,
					DisplayText: item.FieldName,
				}));

			// If no match is found, return a string message
			if (results.length === 0) {
				return Promise.resolve("Sorry, no matches found. Try a different search.");
			}
		}
		return Promise.resolve(results);
	};
  
  
    const togglePopUp = () => {
        setShowAddAttribute(!showAddAttribute)
    }

    const handleAnchorClickAddAttribute = (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => {
        event.preventDefault()
        clearStatusMessage()
        setShowAddAttribute(true)
    }
const toggleAddPrivilegePopup = () => {
    setShowAddPrivilegeRole(!showAddPrivilegeRole)
}

const handleAnchorClickAddPrivilege = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
) => {
    event.preventDefault()
    clearStatusMessage()
    setShowAddPrivilegeRole(true)
}

const toggleAddWorkspacePopup = () => {
    setShowAddWorkspaceRole(!showAddWorkspaceRole)
}

const handleAnchorClickAddWorkspace = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
) => {
    event.preventDefault()
    clearStatusMessage()
    setShowAddWorkspaceRole(true)
}

const toggleRemoveAddToAttributeRole = () => {
    setshowRemoveAddAttributeRole(!showRemoveAddAttributeRole)
}

const handleAnchorClickRemoveAddToAttributeRole = (
    metadataId: number | undefined,
    roleId: number | null
) => {
    if (metadataId && roleId !== null) {
        setPId(metadataId)
        setCurrentRoleId(roleId)
        setshowRemoveAddAttributeRole(true)
    } else {
        console.error('No metadataId or roleId provided for removal.')
    }
}

const toggleRemoveAddToWorkspaceRole = () => {
    setshowRemoveAddWorkSpaceRole(!showRemoveAddWorkSpaceRole)
}

const handleAnchorClickRemoveAddToWorkspaceRole = (
    dashBoardId: number | undefined,
    roleId: number | null
) => {
    if (dashBoardId && roleId !== null) {
        setDashBoardId(dashBoardId)
        setCurrentRoleId(roleId)
        setshowRemoveAddWorkSpaceRole(true)
    } else {
        console.error('No dashBoardId or roleId provided for removal.')
    }
}

const toggleRemoveAddToPrivilegeRole = () => {
    setshowRemoveAddPrivilegeRole(!showRemoveAddPrivilegeRole)
}
const handleAnchorClickRemoveAddToPrivilegeRole = (
    SecEnum: number | undefined,
    roleId: number | null
) => {
    if (SecEnum && roleId !== null) {
        setPId(SecEnum)
        setCurrentRoleId(roleId)
        setshowRemoveAddPrivilegeRole(true)
    } else {
        console.error('No SecEnum or roleId provided for removal.')
    }
}

	const handleFindPrivilege = async (filterText: string): Promise<SearchItem[] | string> => {
		try {

			const attributes = Array.isArray(getfilteredsecurities.securityList) ? getfilteredsecurities.securityList : [];
			let results: SearchItem[];

			if (!filterText?.trim()) {
				// Return all attributes if filterText is empty or only spaces
				results = attributes.map((item: { SecEnum: any; SecCode: any, SecDescription: any }) => ({
					KeyValue: item.SecEnum,
					DisplayText: item.SecCode,
					DisplayDesc: item.SecDescription,
				}));
			} else {
				// Perform case-insensitive match search
				results = attributes
					.filter((item: { SecCode: string }) => item.SecCode.toLowerCase().includes(filterText.toLowerCase()))
					.map((item: { SecEnum: any; SecCode: any, SecDescription: any }) => ({
						KeyValue: item.SecEnum,
						DisplayText: item.SecCode,
						DisplayDesc: item.SecDescription,
					}));

				// If no match is found, return a string message
				if (results.length === 0) {
					return "Sorry, no matches found. Try a different search.";
				}
			}

			return results;
		} catch (error) {
			return "Sorry, no matches found. Try a different search.";
		}
	};
  
  return (
    <>
    <div className="col-12" style={{ marginBottom: '10px' }}>
        {messageVisible && (
          <div
            ref={statusMessageRef}
            id="status_message" className="hide col-12 status-box-compact-success" 
            style={{marginBottom: '10px'}}>
            {statusMessage}
          </div>
        )}
      </div>  
      <div className="col-12 mb-3">
        <div className="float-right margin-top-small">
          <a id="link_backto_admin_tasks" href="#AdminTasks">&laquo;Back to Admin Tasks</a>
        </div>
        <div className="header">Manage Roles</div>
        <br></br>
        <Skeleton loading={loading} height='30px' width='30%'>
          <span>Role: </span>
          {status === "failed" && <p>Error: {error}</p>}
          <select id="select_roles" className="role-dropdown" onChange={handleRoleChange} value={selectedRoleId || ""}>
            {localRolesStatus === "succeeded" &&
              roles.map((role:any) => (
                <option key={role.id} value={role.id}>
                  {role.displayName}
                </option>
              ))
            }
          </select>
        </Skeleton>
      </div>
      
      {/* Manage Data Governance Controls */}
      <div id="role_data" className="col-12">
        <div id="attrhead" className="header">Manage Data Governance Controls</div>
        <div id="attrdesc">
          Manage the attributes that control data scope available to a user with this role.
          Usually, Location is a good baseline standard, but there can be additional and different filters.
        </div>
        <div className="float-right margin-top-small">
          <span id="role_attributes_count" className="sub-info">{roleAttributes.roleSecCount}</span>
          <span id="role_attributes_count_text" className="sub-info"> attribute(s)</span>
          <span className="admin-menu-divider">•</span>
          <a id="link_addnew_role_attribute" href="#" onClick={handleAnchorClickAddAttribute}>Add Attribute to Role</a>
        
          <HLServerSearchListDialog
          isOpen={showAddAttribute}
          onClose={togglePopUp}
          elementObj={roleattributesadd.roleSecurities.RoleAttributes.map(attr => ({
            KeyValue: attr.MetaDataId,  
            DisplayText: attr.FieldName  
        }))}          
          callbacks={{onFind: handleFind, onSave: handleSaveAttributes}}>
          </HLServerSearchListDialog>
        </div>
      </div>
      <AddAttributetoRoleDelete
         isVisible={showRemoveAddAttributeRole}
         onClose={toggleRemoveAddToAttributeRole} 
         title="Remove Attribute for this Role"
         onDelete={handleAddAttributetoRoleRemoveClick}                 
      />
      <div className="padding-bottom-medium"></div>
      <div id="role_attributes_data">
      <Skeleton loading={loading} height='100px' width='100%'>
        <table id="table_role_dashboards" className="admin-table" style={{ width: '100%', tableLayout: 'fixed' }}>
          <thead>
            <tr className="admin-row-header">
              <th style={{ width: '300px', textAlign: 'left' }}>Attribute Name & Description</th>
              <th style={{ width: '100px', textAlign: 'left' }}>Implicit Filter</th>
              <th style={{ textAlign: 'left' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {roleAttributes.AttributeName.length > 0 ? (
              (roleAttributes.AttributeName || []).map((name:string, index:number) => {
                const implicitFilter = roleAttributes.dTO_RoleAttributes?.AttrDetails?.[index]?.ImplicitFilter || false;
                const description = roleAttributes.AttributeDescription[index] || '';
                const metadataId = roleAttributes.dTO_RoleAttributes?.AttrDetails?.[index]?.MetadataId;
                return (
                  <tr key={index} className={index % 2 === 0 ? "admin-row-data" : "admin-alt-row-data"}>
                    <td>
                      <div>
                      <span className="large">{name}</span>                       
                        {description && (
                          <div style={{ color: '#acacac', fontSize: '11px' }}>
                            <span className="smaller sub-info">{description}</span> 
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                    <input
                      type="checkbox"
                      checked={implicitFilters[metadataId] || false} 
                      onChange={() => handleCheckboxChange(metadataId)} 
                    />
                  </td>
                    <td>
                      <a className="cursor-pointer" onClick={(event) => {
                        event.preventDefault(); 
                        if (selectedRoleId !== null) {
                          handleAnchorClickRemoveAddToAttributeRole(metadataId, selectedRoleId);
                        } else {
                          console.error('Selected Role ID is not available.');
                        }
                      }}>
                        Remove
                      </a>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={3}>No attributes assigned.</td>
              </tr>
            )}
          </tbody>
        </table>
        </Skeleton>
      </div>
      {/* Manage Role Workspaces */}
      <div className="padding-bottom-medium"></div>
      <div id="dbhead" className="header">Manage Role Workspaces</div>
      <div className="float-right margin-top-small">
        <span id="role_dashboards_count" className="sub-info">{roledashBoards.roleDashBoardsCount}</span>
        <span id="role_dashboards_count_text" className="sub-info"> workspace(s)</span>
        <span className="admin-menu-divider">•</span>
        <a id="link_addnew_role_dashboard" href="#" onClick={handleAnchorClickAddWorkspace}>Add Workspace to Role</a>
        {getRoleDashBoardsToAdd && (
          <AddWorkspacetoRole
            isVisible={showAddWorkspaceRole}
            onClose={toggleAddWorkspacePopup}
            title="Add Workspace to this Role"
            workSpaceData={getRoleDashBoardsToAdd}
            onSave={handleSaveWorkspace}  
          />
        )}
      </div>
      <AddWorkSpacetoRoleDelete
         isVisible={showRemoveAddWorkSpaceRole}
         onClose={toggleRemoveAddToWorkspaceRole} 
         title="Remove Workspace for this Role"
         deleteWorkSpace={handleAddWorkspacetoRoleRemoveClick}                 
      />
        <div id="dashboard_data">
        <Skeleton loading={loading} height='100px' width='100%'>
         <table id="table_dashboards" className="admin-table">
            <thead>
              <tr className="admin-row-header">
                <th style={{ width: '20%',textAlign: 'left' }}>Workspace Name & Description</th>
                <th style={{ width: '35%',textAlign: 'left' }}>Created By</th>
                <th style={{ width: '35%',textAlign: 'left' }}>Last Updated On</th>
                <th style={{ width: '10%',textAlign: 'left' }}>Actions</th>
              </tr>
            </thead>
             <tbody>
            {roledashBoards.dTO_RoleDashBoardsDetails?.DashBoards?.length > 0 ? (
              (roledashBoards.dTO_RoleDashBoardsDetails?.DashBoards || []).map((dashboard:any, index:number) => {
               return (
                <tr key={index} className={index % 2 === 0 ? "admin-row-data" : "admin-alt-row-data"}>
                  <td style={{ width: '20%' }}>
                  <span className="large" dangerouslySetInnerHTML={{ __html: dashboard.Name }} />
                    {dashboard.Description && (
                        <div
                          style={{ color: '#acacac', fontSize: '11px' }}
                        >
                          <span className="smaller sub-info" dangerouslySetInnerHTML={{ __html: dashboard.Description }} />
                        </div>
                      )}
                  </td>
                  <td style={{ width: '35%', verticalAlign: 'middle', padding: '8px' }}>
                    {dashboard.FirstName && dashboard.LastName ? `${dashboard.FirstName} ${dashboard.LastName}` : null}
                  </td>
                  <td style={{ width: '35%', verticalAlign: 'middle', padding: '8px' }}>
                    {dashboard.LastUpdatedOnValue || null}
                  </td>
                  <td style={{ width: '10%' }}>
                    <a
                      className="cursor-pointer"
                      onClick={(event) => {
                        event.preventDefault();
                        if (selectedRoleId !== null && dashboard.DashBoardId !== null) {
                          handleAnchorClickRemoveAddToWorkspaceRole(dashboard.DashBoardId, selectedRoleId); 
                        }
                      }}
                    >
                      Remove
                    </a>
                  </td>
                </tr>
               );
              })
            ) : (
              <tr>
                <td colSpan={4}>No workspaces assigned</td>
              </tr>
            )}
          </tbody> 
        </table>
      </Skeleton>
      </div>
      {/* Manage Role Securities */}
      <div className="padding-bottom-medium"></div>
      <div id="sechead" className="header">Manage Role Securities</div>
      <div className="float-right margin-top-small">
        <span id="role_priviliges_count" className="sub-info">{roleSecurityDetails.roleSecCount}</span>
        <span id="role_priviliges_count_text" className="sub-info"> privilege(s)</span>
        <span className="admin-menu-divider">•</span>
        <a id="link_addnew_role_security" href="#" onClick={handleAnchorClickAddPrivilege}>Add Privilege to Role</a>
       
         <HLServerSearchListDialog
          isOpen={showAddPrivilegeRole}
          onClose={toggleAddPrivilegePopup}
          elementObj={getRoleSecurity.roleSecurities.RoleSecurityCodes
            .map(attr => ({
            KeyValue: attr.SecEnum, 
            DisplayText: attr.SecCode,
			DisplayDesc: attr.SecDescription
          }))}        
          callbacks={{
            onFind: handleFindPrivilege,
            onSave: (selectedItems: SearchItem[]) =>
              handleSavePrivilege(selectedItems.map(item => item.KeyValue))
          }}>
          </HLServerSearchListDialog>
          <AddPrivilegetoRoleDelete
         isVisible={showRemoveAddPrivilegeRole}
         onClose={toggleRemoveAddToPrivilegeRole} 
         title="Remove Privilege for this Role"
         deletePrivilege={handleAddPrivilegetoRoleRemoveClick}                 
      />
      </div>
      <div id="role_priviliges_data"></div>
      <div id="role_security_data">
      <Skeleton loading={loading} height='100px' width='100%'>
        <table id="table_security" className="admin-table">
          <thead>
            <tr className="admin-row-header">
              <th style={{ width: '20%',textAlign: 'left' }}>Security Feature</th>
              <th style={{ width: '70%',textAlign: 'left' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
              {roleSecurityDetails.FeaturesSecurity?.length > 0 ? (
                (roleSecurityDetails.FeaturesSecurity || []).map((rolesecurity:any, index:number) => {
                  return (
                    <tr key={index} className={index % 2 === 0 ? "admin-row-data" : "admin-alt-row-data"}>
                      <td style={{ width: '20%' }}>
                        <div>
                          <span className="large">{rolesecurity.SecCode}</span>
                        </div>
                        {rolesecurity.SecDescription && (
                          <div style={{ maxWidth: '100ch', wordBreak: 'break-word' }}>
                            <span
                              className="smaller sub-info"
                              style={{ color: '#acacac', fontSize: '11px', lineHeight: '13px' }}
                            >
                              {rolesecurity.SecDescription}
                            </span>
                          </div>
                        )}
                      </td>
                      <td style={{ width: '70%' }}>
                        <a
                          className="cursor-pointer"
                          onClick={(event) => {
                            event.preventDefault();
                            if (selectedRoleId !== null) {
                              handleAnchorClickRemoveAddToPrivilegeRole(rolesecurity.SecEnum, selectedRoleId);
                            } else {
                              console.error('Selected Role ID is not available.');
                            }
                          }}
                        >
                          Remove
                        </a>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={2}>No privileges assigned</td>
                </tr>
              )}
            </tbody>

        </table>
        </Skeleton>
      </div>
    </>
  );
};

export default ManageRoles;












